import Values from "values.js"

export function isColorDark(color: string): boolean {
	const [red, green, blue] = new Values(color).rgb
	return red * 0.299 + green * 0.587 + blue * 0.114 <= 186
}
